import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuTha = () => {
  const [isOpen, setIsOpen] = useState(false)
                      
  const toggle = () => {
  setIsOpen(!isOpen)
  }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
         <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                              KALLA THAILÄNDSKA DELIKATESSER
                            </div><br /><br />
                            <div className='menu_mat'>
                              Thai beef salad – tunt skivat nötkött med lime, chili, mynta & koriander.
                              <br /><br />
                              Glasnudelsallad med räkor, lime, chili & färska örter.
                              <br /><br />
                              Som Tam – grön papayasallad med lime, chili & jordnötter.
                              <br /><br />
                              Gurksallad med chili, lime & sesam.
                              <br /><br />
                              Mango- & kålsallad med färska örter.
                              <br /><br />
                              Edamame med havssalt & chili.
                              <br /><br />
                              Picklade grönsaker.
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                THAILÄNDSKA SMAKBITAR
                              </div><br /><br />
                              <div className='menu_mat'>
                                Crispy räkor med sweet chili & lime.
                                <br /><br />
                                Chicken satay med jordnötssås.
                                <br /><br />
                                Vegetariska vårrullar med sweet chili.
                                <br /><br />
                                Mini Thai fish cakes med färska örter.
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                VARMA THAILÄNDSKA SPECIALITETER
                              </div><br /><br />
                            <div className='menu_mat'>
                              Thai Red Curry - 
                              Kyckling i röd currysås med kokosmjölk, paprika, bambuskott & färska örter.
                              <br /><br />
                              Thai Basil Beef - 
                              Wokat nötkött med chili, vitlök, thaibasilika & soja.
                              <br /><br />
                              Chicken Cashew - 
                              Wokad kyckling med cashewnötter, paprika, lök & chili.
                              <br /><br />
                              Pad Thai - 
                              Klassiska risnudlar med räkor, ägg, böngroddar, jordnötter & lime.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              RIS & TILLBEHÖR
                                </div><br /><br />
                                <div className='menu_mat'>
                                  Jasminris.
                                  <br /><br />
                                  Kokosris.
                                  <br /><br />
                                  Wokade grönsaker med ingefära & vitlök.
                                  <br /><br />
                                  Stekt ris med ägg & grönsaker.
                                  <br /><br />
                                  Färsk koriander, lime & chili.
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                   SÅSER & TOPPINGS
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Sweet chili.
                                    <br /><br />
                                    Jordnötssås.
                                    <br /><br />
                                    Sriracha.
                                    <br /><br />
                                    Nam pla-lime-dressing.
                                    <br /><br />
                                    Rostade jordnötter.
                                    <br /><br />
                                    Krispig lök.
                                    <br /><br />
                                    Färsk koriander & thaibasilika.
                                    <br /><br />
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                THAILÄNDSKA DESSERTER
                        </div><br /><br />
                        <div className='menu_mat'>
                          Mango Sticky Rice – kokosris med färsk mango.
                          <br /><br />
                          Kokospannacotta med lime.
                          <br /><br />
                          Mini kokosbollar.
                          <br /><br />
                          Friterad banan med honung.
                          <br /><br />
                          Färsk mango, ananas & passionsfrukt.
                        </div>
                    </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuTha